import React, {Fragment, useState} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {GUTTER_MD, MARGIN_MD} from "../../../../styles/constants";
import {Button, Card, Col, Row} from "antd";
import CSVPreview from "./CSVPreview";
import {downloadConvertedPluginFile, getCSVPreview} from "../actions";
import {connect} from "react-redux";
import FileSaver from "file-saver";

const mapStateToProps = state => ({
    pluginForm: state.scenes.utilities.plugins.pluginForm,
    outputFilePath: state.scenes.utilities.plugins.outputFilePath,
    csvPreviewParams: state.scenes.utilities.plugins.csvPreviewParams,
})

const mapDispatchToProps = dispatch => ({
    onDownload: outputFilePath => dispatch(downloadConvertedPluginFile(outputFilePath.replace("\\", ""))),
    onDownloadReport: (info, plugin, t, lang) => {
        const file = new File([`${Object.keys(info).map(k => t(`scenes.utilities.plugin.modal.output.report.${k}`)).join(",")}\n${Object.values(info).join(",")}`], "test.csv", {type: "text/csv;charset=utf-8"});
        FileSaver.saveAs(file, `report_${plugin.PluginName[lang].replaceAll(" ", "-")}_${new Date().toISOString()}.csv`);
    },
    onCsvPreview: (outputFilePath, csvPreviewParams) => dispatch(getCSVPreview(outputFilePath, csvPreviewParams)),
});

const SecondStep = ({
                        t,
                        plugin,
                        outputFilePath,
                        pluginForm,
                        onDownload,
                        onDownloadReport,
                        onCsvPreview,
                        csvPreviewParams,
                        lang
                    }) => {
    const [isCsvPreviewVisible, setIsCsvPreviewVisible] = useState(false);
    return <Fragment>
        {plugin.OutputExtension === '.csv' &&
            <CSVPreview isVisible={isCsvPreviewVisible} onHide={() => setIsCsvPreviewVisible(false)} />}

        {plugin.ReportEnabled && (
            <Card title="Report" type="inner" headStyle={{fontWeight: "bold"}} style={{marginBottom: MARGIN_MD}}>
                {Object.keys(pluginForm.response || {}).filter(key => !!pluginForm.response[key] || pluginForm.response[key] === 0).map(key => {
                    const value = pluginForm.response[key];
                    return (<Row style={{marginBottom: MARGIN_MD}} key={key}
                                 gutter={GUTTER_MD}><Col><span style={{fontWeight: "bold"}}>{t(`scenes.utilities.plugin.modal.output.report.${key}`)}:</span> {value}</Col></Row>)
                })}
            </Card>
        )}
        <div style={{display: "flex", gap: GUTTER_MD}}>
            <Button type="primary" onClick={() => onDownload(outputFilePath)}>{t("scenes.utilities.plugin.modal.output.actions.downloadFile")}</Button>
            {plugin.ReportEnabled &&
                <Button icon="download" type="default" onClick={() => onDownloadReport(pluginForm.response, plugin, t, lang)}>
                    {t("scenes.utilities.plugin.modal.output.actions.downloadReport")}
                </Button>
            }
            {plugin.OutputExtension === '.csv' &&
                <Button icon="table" type="ghost" onClick={() => {
                    onCsvPreview(outputFilePath, csvPreviewParams);
                    setIsCsvPreviewVisible(true);
                }}>
                    {t("scenes.utilities.plugin.modal.output.actions.previewCSV")}
                </Button>
            }
        </div>
    </Fragment>
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
)(SecondStep);